import { Assessment } from '@/types/assessment';
import { Button } from '@/components/ui/button';
import { ArrowUpRight } from 'lucide-react';
import backgroundImage from '@/assets/assessment-welcome-bg.jpg';
import ObjectiveIcon from '@/assets/icons/Objective.svg';
import CategoriesIcon from '@/assets/icons/Categories.svg';
import TimeIcon from '@/assets/icons/TIme.svg';
import PersonalisedIcon from '@/assets/icons/Personlised.svg';
import gapstarsLogo from '@/assets/logo.png';
interface AssessmentWelcomeProps {
  assessment: Assessment;
  onStart: () => void;
}
const AssessmentWelcome = ({
  assessment,
  onStart
}: AssessmentWelcomeProps) => {
  // Count free questions
  const freeQuestionsCount = assessment.categories.reduce((count, category) => count + category.questions.filter(q => !q.premium).length, 0);
  const features = [{
    icon: ObjectiveIcon,
    title: "Understand your current<br/>maturity level",
    description: ""
  }, {
    icon: CategoriesIcon,
    title: "Contains 17 questions<br/>across 3 categories",
    description: ""
  }, {
    icon: TimeIcon,
    title: "Takes approximately<br/>9 minutes to complete",
    description: ""
  }, {
    icon: PersonalisedIcon,
    title: "Receive personalized<br/>recommendations based<br/>on your inputs",
    description: ""
  }];
  return <div className="grid lg:grid-cols-2 gap-0 min-h-screen font-helios">
      {/* Left Side - Content */}
      <div className="bg-white flex flex-col justify-center p-8 lg:p-16">
        <div className="w-full">
          {/* Branding */}
          <div className="mb-8 flex items-center gap-3">
            <img src={gapstarsLogo} alt="Maturity Compass Logo" className="h-12 w-auto object-contain" />
            <span className="text-2xl font-bold text-foreground tracking-wide">GAPSTARS</span>
          </div>

          {/* Title */}
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-8 leading-tight">
            Welcome to the {assessment.title}
          </h2>

          {/* Feature Cards Grid */}
          <div className="grid grid-cols-2 gap-4 mb-8 max-w-2xl">
            {features.map((feature, index) => <div key={index} className="flex items-center gap-4 p-5 rounded-lg bg-gray-900 w-full min-h-[95px]">
                <img src={feature.icon} alt="" className="h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0" />
                <p className="text-sm text-white leading-relaxed text-justify">
                  <span dangerouslySetInnerHTML={{
                __html: feature.title
              }} />
                </p>
              </div>)}
          </div>

          {/* Description */}
          <p className="text-sm text-muted-foreground mb-6 max-w-2xl">
            This assessment will help you identify your current capabilities and set targets<br />
            for improvement.
          </p>

          {/* CTA Button */}
          <Button onClick={onStart} className="text-white pl-8 pr-1 py-1 font-semibold text-base inline-flex items-center gap-4 w-fit h-12 relative" style={{
          backgroundColor: '#E77A2E',
          borderRadius: '30px',
          minWidth: '246px'
        }}>
            Let's get started!
            <div className="bg-white rounded-full p-2.5 flex items-center justify-center">
              <ArrowUpRight className="h-5 w-5 text-orange-500" />
            </div>
          </Button>
        </div>
      </div>
      
      {/* Right Side - Background Image */}
      <div className="relative bg-center bg-no-repeat hidden lg:block" style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: '150%'
    }}>
        <div className="absolute inset-0 bg-black/20"></div>
      </div>
    </div>;
};
export default AssessmentWelcome;